var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layoutGuestAnnouncement"},[_c('div',{staticClass:"header"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('main',[_c('Loading',{attrs:{"loading":_vm.getIsLoading}},[_c('router-view')],1)],1),_c('PopupCommon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }